import React from "react";
import { useNavigate } from "react-router-dom";
import {
    IoPersonOutline,
    IoKeyOutline,
    IoPeopleOutline,
    IoRibbonOutline,
    IoShieldCheckmarkOutline,
    IoChevronForwardOutline,
} from "react-icons/io5";
import { MdStar } from "react-icons/md";
import { useDispatch } from "react-redux";
import { logout } from "../store/slice/authSlice";

const ProfilePage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogout = () => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        dispatch(logout()); // твой logout reducer
        navigate("/login");
    };

    return (
        <div className="profile-container">
            <div className="prime-section">
                <div className="prime-header">
                    <h2 className="prime-title"></h2>
                </div>

            </div>

            <div className="profile-options">
                {/* <ProfileOption icon={<IoPersonOutline />} label="Личная информация" /> */}
                <ProfileOption icon={<IoRibbonOutline />} label="Заполнить персональные данные" onClick={() => navigate("/personal-info")} />
                <ProfileOption icon={<IoShieldCheckmarkOutline />} label="Договоры и правила" onClick={() => navigate("/agreement")} />
                <ProfileOption icon={<IoKeyOutline />} label="Правила переупаковки" onClick={() => navigate("/repack-consent")} />
                <ProfileOption icon={<IoRibbonOutline />} label="Выйти" onClick={() => { handleLogout() }} />
            </div>
        </div>
    );
};

const ProfileOption = ({ icon, label, onClick = () => { } }) => (
    <div className="profile-option" onClick={onClick}>
        <div className="option-content">
            <span className="option-icon">{icon}</span>
            <span className="option-label">{label}</span>
        </div>
        <IoChevronForwardOutline className="chevron-icon" />
    </div>
);

export default ProfilePage;
